// src/components/Public/PriceRangeListings.js
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function PriceRangeListings() {
  const { range } = useParams();
  
  const formatRange = (range) => {
    const ranges = {
      'under-500k': 'Under RM 500K',
      '500k-1m': 'RM 500K - 1M',
      '1m-2m': 'RM 1M - 2M',
      'above-2m': 'Above RM 2M'
    };
    return ranges[range] || range;
  };
  
  return (
    <>
      <Helmet>
        <title>{formatRange(range)} Properties | Property Listings</title>
      </Helmet>
      <div style={containerStyle}>
        <h1>Properties in {formatRange(range)} Range</h1>
        <p>This feature will be available soon. Price range filtering is coming!</p>
        <Link to="/" style={linkStyle}>← Back to All Properties</Link>
      </div>
    </>
  );
}

// Styles
const containerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '40px 20px',
  textAlign: 'center',
};

const linkStyle = {
  display: 'inline-block',
  marginTop: '20px',
  padding: '10px 20px',
  backgroundColor: '#007bff',
  color: 'white',
  textDecoration: 'none',
  borderRadius: '5px',
  fontWeight: 'bold',
};

export default PriceRangeListings;